import { Button, SxProps, Theme } from '@mui/material'
import { i18nTranslationHelper } from '@/i18n'

export type LinkButtonProps = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
  href: string
  cta: React.ReactNode
  ariaLabel?: string
  sx?: SxProps<Theme>
  target?: string
  rel?: string
}

export default function LinkButton({ href, cta, ariaLabel, sx, target, rel }: LinkButtonProps) {
  const t = i18nTranslationHelper.getTComponents

  return (
    <Button
      component="a"
      href={href}
      aria-label={ariaLabel}
      sx={{
        ...sx,
        padding: 0,
        minWidth: 0,
        verticalAlign: 'baseline'
      }}
      target={target}
      rel={target === '_blank' ? 'noopener noreferrer' : rel}
    >
      {cta}
      {target === '_blank' && <span className="sr-only"> {t('accessibility.openInNewTab')}</span>}
    </Button>
  )
}
